import { ReactElement } from 'react';
import { useFormikContext } from 'formik';
import { NEW_NON_EMPLOYEE_KEYS } from '../../_const';
import ReviewAndSubmitNewNonEmployee from 'pages/NewNonEmployee/components/views/ReviewAndSubmitNonEmployee';

/**
 * Display information about the form before submission
 * @returns {ReactElement} component displaying information about the errors or the submission details
 */
const ReviewAndSubmitEpicCareLinkUser = () => {
	const { values } = useFormikContext();
	const details = [];
	details.push({
		key: 'First Name',
		value: values[NEW_NON_EMPLOYEE_KEYS.FIRST_NAME],
	});
	details.push({
		key: 'Last Name',
		value: values[NEW_NON_EMPLOYEE_KEYS.LAST_NAME],
	});
	details.push({
		key: 'Middle Initial',
		value: values[NEW_NON_EMPLOYEE_KEYS.MIDDLE_INITIAL],
	});
	details.push({
		key: 'Email',
		value: values[NEW_NON_EMPLOYEE_KEYS.ALTERNATE_EMAIL],
	});
	details.push({
		key: 'Date of Birth',
		value: values[NEW_NON_EMPLOYEE_KEYS.DATE_OF_BIRTH],
	});
	details.push({
		key: 'Phone Number',
		value: `${values[NEW_NON_EMPLOYEE_KEYS.PHONE_NUMBER]} ${
			values[NEW_NON_EMPLOYEE_KEYS.PHONE_NUMBER_EXTENSION]
		}`,
	});
	details.push({
		key: 'Identifier',
		value: values[NEW_NON_EMPLOYEE_KEYS.IDENTIFIER_NUMBER],
	});
	details.push({
		key: 'Site Administrator',
		value:
			values[NEW_NON_EMPLOYEE_KEYS.IS_SITE_ADMIN] === 'true'
				? 'yes'
				: 'no',
	});

	return (
		<ReviewAndSubmitNewNonEmployee
			summary='Upon submission, you will be creating a new non-employee that will be configured to be an EpicCare Link user.'
			details={details}
		/>
	);
};

export default ReviewAndSubmitEpicCareLinkUser;
